import { render, staticRenderFns } from "./PayBtn.vue?vue&type=template&id=88461a5e&scoped=true&"
import script from "./PayBtn.vue?vue&type=script&lang=ts&"
export * from "./PayBtn.vue?vue&type=script&lang=ts&"
import style0 from "./PayBtn.vue?vue&type=style&index=0&id=88461a5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88461a5e",
  null
  
)

export default component.exports